var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8155 26.6034H44.2985C44.2985 22.9602 41.2221 20.0455 37.483 20H23C23 23.6433 26.0765 26.6034 29.8155 26.6034Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34.892V44.0002H23.0473C27.1177 44.0002 30.4308 40.7668 30.4308 36.8503V34.9376H31.6614C35.4478 34.9376 38.5243 31.9774 38.5243 28.3341H29.8629C26.0765 28.3341 23 31.2487 23 34.892Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinchLogo);
export default __webpack_public_path__ + "static/media/finchLogo.c551302ed3273bdfb3bcd76d2905a436.svg";
export { ForwardRef as ReactComponent };